import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row text-muted">
          <div className="col-12 text-center">
            <p className="mb-0">
              <small>
                © Copyrights{' '}
                <script type="text/javascript">
                  var year = new Date();document.write(year.getFullYear());
                </script>
                2025. Powered by{' '}
                <a href="https://orimarktechnologies.com/" target="_blank" rel="noreferrer">
                  Orimark Technologies Pvt. Ltd
                </a>
              </small>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
